export default __webpack_public_path__ + "static/media/grafema_nutrana_09.12f3fb2d.mp4";